import { ICardMotorsportsResults, CardMotorsportsResults } from "@sky-it-livedata/livedata-sports-design-system";

import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { DataCardGpResultsQuery } from "./types";

import transformQuery from "./transformers/query-transformer";
import { useIntcmp } from "../../hooks/useIntcmp";

export const setCustomAttributes = ({
  variables,
}: WidgetContext<DataCardGpResultsQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

export const getServerProps = ({
  props,
}: WidgetContext<DataCardGpResultsQuery>): ICardMotorsportsResults => {
  return transformQuery(props);
}

const ResultsContainer = ({
  props,
  ...rest
}: WidgetContext<ICardMotorsportsResults>) => {
  log({ props, ...rest });
  const intCmpEventHandler = useIntcmp();

  return (
    <div onClick={intCmpEventHandler}>
        <CardMotorsportsResults {...props} />
    </div>
  );
}

export default ResultsContainer;